awaitRefetchQueries